import React from 'react';
import { Button as BSButton } from 'react-bootstrap';

import { Unidade } from 'helper/windx';

import './Unit.scss';

interface UnitProps {
  valor: Unidade;
  onChange: (valor: Unidade) => void;
  /**
   * Variante mobile: controle segmentado de largura total, com as duas opcoes
   * dividindo o espaco igualmente (prototipo Windx mobile). Ignorada no
   * desktop, que continua com o pill `mode-switcher` de sempre.
   */
  segmentado?: boolean;
}

const OPCOES: { id: Unidade; label: string }[] = [
  { id: 'mw', label: 'Geração' },
  { id: 'fc', label: 'Fator de Capacidade' },
];

export default function Unit({ valor, onChange, segmentado = false }: UnitProps) {
  // A variante segmentada NAO reusa `mode-switcher`: aquela classe e global
  // (vem de Meteorology/Fields/ControlPanel/ObservedData) e traz `width: 100%`
  // com itens do tamanho do texto — era dai que vinha a sobra cinza a direita.
  if (segmentado) {
    return (
      <div className="windx-unit-seg">
        {OPCOES.map((o) => (
          <button
            key={o.id}
            type="button"
            className={`windx-unit-seg-item${valor === o.id ? ' is-ativo' : ''}`}
            onClick={() => onChange(o.id)}
          >
            {o.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="mode-switcher windx-unit">
      {OPCOES.map((o) => {
        const ativo = valor === o.id;
        return (
          <div
            key={o.id}
            className={ativo ? 'mode-selector-current' : 'mode-selector'}
          >
            <BSButton
              variant="link"
              size="sm"
              className="button-link"
              onClick={() => onChange(o.id)}
            >
              {o.label}
            </BSButton>
          </div>
        );
      })}
    </div>
  );
}
